<template>
  <div class="d-flex">
    <button
      class="btn btn-info ml-auto"
      :class="{ 'mt-1': !appended }"
      v-if="is_changed"
      @click="revert()"
      :title="value_is_changed_text"
    >
      <span>{{ 'change_back' | t }}</span>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | null,
      required: true
    },
    default_value: {
      type: String | null,
      required: false,
      default: null
    },
    appended: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      initial_value: null
    };
  },
  mounted() {
    if (this.value) {
      this.initial_value = this.value;
    }
  },
  computed: {
    is_changed() {
      if (this.initial_value === null) {
        return false;
      }

      return this.value !== this.initial_value;
    },
    /**
     * @return {string}
     */
    value_is_changed_text() {
      if (this.initial_value === '' || this.initial_value === null) {
        return `Changed from no input to "${this.value}"`;
      }
      return `Changed from "${this.initial_value}" to "${this.value}"`;
    }
  },
  methods: {
    revert() {
      this.$emit('revert', this.initial_value !== null ? this.initial_value : this.default_value);
    }
  }
};
</script>
